import { gql } from '@apollo/client';

export const REMOVE_INCIDENT_NARRATIVE = gql`
mutation removeIncidentNarrative($input: RemoveIncidentNarrativeInput!) {
  removeIncidentNarrative(input: $input) {
    __typename
    clientMutationId
    errors
    incidentNarrativeUuid
  }
}
`
